"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var renderPaths_exports = {};
__export(renderPaths_exports, {
  renderPaths: () => renderPaths
});
module.exports = __toCommonJS(renderPaths_exports);
var import_react = require("react");
function kebabToCamelCase(str) {
  return str.replace(/-([a-z])/g, (_, $1) => $1.toUpperCase());
}
function reactAttributes(obj) {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (key === "style" && typeof value === "string") {
      acc.style = value.split(";").reduce((styleAcc, item) => {
        const [styleKey, styleValue] = item.split(":");
        if (styleKey && styleValue) {
          styleAcc[kebabToCamelCase(styleKey.trim())] = styleValue.trim();
        }
        return styleAcc;
      }, {});
    } else {
      acc[kebabToCamelCase(key)] = value;
    }
    return acc;
  }, {});
}
function renderPaths(nodes) {
  if (!nodes) return;
  return nodes.map(
    (node) => (0, import_react.createElement)(node.tag, reactAttributes(node.att), renderPaths(node.nds))
  );
}
